<template>
  <f7-page class="home-page">
    <template #fixed>
      <MainHeaderComponent type="back" />
    </template>

    <div class="bg-gray title-container">
      <div class="title">
        <font-awesome-icon :icon="['fad', 'cog']" fixed-width />

        <div class="text">
          <h1>{{ $t.getTranslation('LBL_COUPON_SAVE') }}</h1>
        </div>
      </div>

      <div class="button-container">
        <f7-button large fill raised @click="create" :disabled="!formData.CouponId">{{ $t.getTranslation("LBL_TIER") }}</f7-button>
      </div>

      <div class="button-container"></div>
    </div>

    <section class="form-container">
      <div class="container">
        <f7-list no-hairlines>
          <f7-list-item divider>{{ $t.getTranslation("LBL_COUPON_DETAILS") }}</f7-list-item>

          <f7-list-input
            v-model:value="formData.CouponRuleTranslation.EN"
            name="RuleName"
            :required="validationRules?.Name?.required"
            :minlength="validationRules?.Name?.minimumLength"
            :maxlength="validationRules?.Name?.maximumLength"
            :label="$t.getTranslation('LBL_RULE_NAME_EN')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="text"
            placeholder=""
            validate
          >
          </f7-list-input>

          <f7-list-input
            v-model:value="formData.CouponRuleTranslation.CHS"
            name="RuleName"
            :required="validationRules?.Name?.required"
            :minlength="validationRules?.Name?.minimumLength"
            :maxlength="validationRules?.Name?.maximumLength"
            :label="$t.getTranslation('LBL_RULE_NAME_CHS')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="text"
            placeholder=""
            validate
          >
          </f7-list-input>

          <f7-list-input
            v-model:value="formData.StartDate"
            name="StartDate"
            :required="validationRules?.StartDate?.required"
            :minlength="validationRules?.StartDate?.minimumLength"
            :maxlength="validationRules?.StartDate?.maximumLength"
            :label="$t.getTranslation('LBL_VALID_FROM')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="datetime-local"
            placeholder="YYYY/MM/DD"
            validate
          >
          </f7-list-input>

         <f7-list-input
            v-model:value="formData.EndDate"
            name="StartDate"
            :required="validationRules?.EndDate?.required"
            :minlength="validationRules?.EndDate?.minimumLength"
            :maxlength="validationRules?.EndDate?.maximumLength"
            :label="$t.getTranslation('LBL_VALID_TO')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="datetime-local"
            placeholder="YYYY/MM/DD"
            validate
          >
          </f7-list-input>

          
          <f7-list-input
            v-model:value="formData.StatusCode"
            name="StatusCode"
            :required="validationRules?.StatusCode?.required"
            :minlength="validationRules?.StatusCode?.minimumLength"
            :maxlength="validationRules?.StatusCode?.maximumLength"
            :label="$t.getTranslation('LBL_STATUS')"
            :placeholder="$t.getTranslation('LBL_TYPE_HERE')"
            :info="$t.getTranslation('LBL_INFO_FIELD_OPTIONAL')"
            :error-message="$t.getLanguage() != 'EN' ? $t.getTranslation('LBL_ERROR_FIELD') : ''"
            floating-label
            outline
            type="select"
            validate
          >
            <option v-for="status in statusList" :key="'st_' + status.Code" :value="status.Code">{{ status.Name }}</option>
          </f7-list-input>


          <f7-button large fill raised preloader @click="saveData">
              {{ $t.getTranslation("LBL_SAVE") }}
          </f7-button>

           <f7-button large fill raised preloader @click="back">
              {{ $t.getTranslation("LBL_BACK") }}
          </f7-button>

        </f7-list>
      </div>
    </section>

    <MainFooterComponent />
  </f7-page>
</template>

<script>
import { defineComponent, ref, computed, reactive, onMounted, inject } from "vue";

import { useStore } from "@/store";

import { $HTTP } from "@/utils/axios";
import { helpers } from "@/utils/helpers.js";

import { validations } from "@/utils/validations";
import validationRulesConfig from "@/validationRules";

import MainHeaderComponent from "@/components/MainHeaderComponent.vue";
import MainFooterComponent from "@/components/MainFooterComponent.vue";

export default defineComponent({
  name: "BannerSavePage",
  components: {
    MainHeaderComponent,
    MainFooterComponent,
  },
  props: { f7router: Object, f7route: Object },
  setup(props) {
    const $t = inject("$translation");
    const store = useStore();
    const isUpdate = ref(false);
    const isButtonProcessing = ref(false);
    const statusList = computed(() => store.getters["config/getData"]?.statusList);
    const currentLanguageCode = computed(() => store.getters["translation/getLanguage"]);
    const uploadedImages = ref([]);
    const couponId = ref(null);
    const formData = reactive({
      CouponTranslation: {},
      CouponRuleTranslation: {},
      StatusCode: ""
    });
 
    let validationRules = {};
    for (let keys in formData) {
      if (validationRulesConfig && validationRulesConfig[keys]) {
        validationRules[keys] = validationRulesConfig[keys];
      }
    }


    onMounted(async() => {
      if (props?.f7route?.query && props?.f7route?.query?.CouponId) {
        isUpdate.value = true;
        couponId.value = props?.f7route?.query?.CouponId;
        await getData();
      }
    });

    
    const getData = async () => {
      try {
        helpers.showLoader();
        let res = await $HTTP.get(`/admin/coupon/view?CouponId=${couponId.value}&LanguageCode=${currentLanguageCode.value || 'EN'}`);
        if (res?.status === 200 && res?.data?.data) {
          helpers.hideLoader();

          for (var key in res?.data?.data) {
            formData[key] = res?.data?.data[key];
          }
      
          formData.StartDate = helpers.formatDatimeTimePicker(formData.StartDate)
          formData.EndDate =  helpers.formatDatimeTimePicker(formData.EndDate)


          helpers.hideLoader();
          return;
        }
        throw new Error($t.getTranslation("ERR_SERVER_NOT_RESPONDING"));
      } catch (err) {
        helpers.hideLoader();
        helpers.catchError(err, true);
      }
    };


    const saveData = async () => {
      try {
        helpers.showLoader();
        
        formData.StartDate = helpers.formatSQLDateTime(formData.StartDate);
        formData.EndDate = helpers.formatSQLDateTime(formData.EndDate);

        let StartDate = new Date(formData.StartDate).getTime();
        let EndDate = new Date(formData.EndDate).getTime();

        if (EndDate < StartDate) {
          throw new Error($t.getTranslation("ERR_INVALID_DATE"));
        }

        let res = await $HTTP.post(`/admin/coupon/save`, formData);
        if (res?.status === 200 && res?.data?.data) {
          formData.CouponId = res?.data?.data.CouponId;
          couponId.value =  res?.data?.data.CouponId;
          helpers.createNotification({ type: "success", title: $t.getTranslation("LBL_SUCCESS"), message: $t.getTranslation("LBL_INFO_SUCCESSFULLY_SAVE_COUPON") });
          await getData();
          helpers.hideLoader();
          return;
        }
        throw new Error($t.getTranslation("ERR_SERVER_NOT_RESPONDING"));
      } catch (err) {
        helpers.hideLoader();
        helpers.catchError(err, true);
      }
    };



    const validate = (showNotifications) => {
      const isValid = validations.validate({
        validateData: formData,
        validationRules: validationRules,
        showNotifications: showNotifications,
      });

      return isValid;
    };

    const isDisableSaveButton = computed(() => {
      let isValid = validate(false);

      return !isValid;
    });

    const back = () => {
      props.f7router.navigate({ name: "couponList", params: {}, query: {} });
    }

    const create = () => {
      props.f7router.navigate({ name: "couponListTier",  query: {CouponId: couponId.value} });
    }

    

    return { isUpdate, formData, validationRules, isButtonProcessing, isDisableSaveButton, back, statusList, saveData, create };
  },
});
</script>
